import { Box } from '@mui/material';
import React, { FC } from 'react';
import colors from 'src/styles/equalution/colors';
import Fonts from 'src/styles/equalution/fonts';

export type PlanBadgeType = 'Popular' | 'Best value';

interface PlanBadgeProps {
  type: PlanBadgeType;
}

const PlanBadge: FC<PlanBadgeProps> = ({ type }) => {
  const isPopular = type === 'Popular';

  return (
    <Box
      sx={{
        display: 'inline-block',
        backgroundColor: isPopular ? colors.OFF_BLACK : colors.ORANGE_HALF,
        color: isPopular ? colors.WHITE : colors.OFF_BLACK,
        borderRadius: '24px',
        paddingInline: '8px',
        fontSize: '12px',
        fontWeight: 600,
        fontFamily: Fonts.FontType.regular,
        mt: 0.5,
        width: 'fit-content',
      }}>
      {type}
    </Box>
  );
};

export default PlanBadge;
